import React, { useState, useMemo, useEffect } from "react";
import Button from "../../Elements/Button/Button.js";
import Login from "../../Structure/Login/Login.js";
import Icon from "../../Elements/Icon/Icon.tsx";
import Form from "../Form/Form.js";
import Progressbar from "../Progressbar/Progressbar.js";
import JumboPayProcessContainer from "./JumboPayProcessContainer.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import Image from "../../Elements/Image/Image.tsx";
import externalSubmit from "../Form/externalSubmit.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { billingFields, billingSingUpFields } from "./billingFields.js";
import { useRef } from "react";
import { LinkToNewTab } from "../../Elements/Link/Link.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useToasts } from "react-toast-notifications";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { currencies } from "../../../utils/gridHelpers.js";
// import "../../Structure/ModalManager/ModalManager.scss";

const StageOneComponent = ({
  handleSubmit,
  checkIfMailIsExist,
  externalBlurStatus,
  formRef,
}) => {
  const { setModal } = useModal();
  const { isLoggedIn, getUserData } = useUser();
  const { getTextByKey } = useContent();

  return (
    <>
      {isLoggedIn() ? null : (
        <div className="login-text">
          {getTextByKey("jumbopay-login-question")}
          <a
            onClick={() =>
              setModal({
                modal: Login,
                modalSize: "full-modal",
                props: {
                  submitCallback: () => {
                    setModal({
                      modal: JumboPayProcessModal,
                      container: JumboPayProcessContainer,
                    });
                  },
                },
              })
            }
          >
            {getTextByKey("login")}
          </a>
        </div>
      )}
      <div className="jumbopay-form-container">
        <div className="form-header">{getTextByKey("billing-info-text")}</div>
        <Form
          fields={isLoggedIn() ? billingFields : billingSingUpFields}
          fieldsProps={{ field: "square", label: "hidden-mobile" }}
          onSubmit={handleSubmit}
          defaultValuesObj={
            isLoggedIn()
              ? {
                  FirstName: getUserData().UserFirstName,
                  PhoneNumber: getUserData().UserPhone,
                  LastName: getUserData().UserLastName,
                  Email: getUserData().UserName,
                  PaymentMethod: "creditcard",
                }
              : {
                  PaymentMethod: "creditcard",
                }
          }
          ref={formRef}
        />
      </div>
    </>
  );
};

const ResultComponent = ({ isSuccess, setProcessStage }) => {
  const { getTextByKey } = useContent();
  return (
    <div className="jumbopay-result-container">
      <div className="icon-container">
        {isSuccess ? (
          <>
            <Icon name="credit-card" blue />
            <div className="success-icon-container">
              <Icon name="check" blue />
            </div>
          </>
        ) : (
          <Icon name="warning" red />
        )}
      </div>
      <div className="content-conatiner">
        {isSuccess ? (
          <>
            <div className="title-text">
              {getTextByKey("jumbopay-success-payment-title")}
            </div>
            <div className="subtitle-text">
              {getTextByKey("jumbopay-success-payment-text")}
            </div>
            <Button
              title={getTextByKey("jumbopay-success-payment-button-text")}
              onClick={() => window.location.reload()}
            />
          </>
        ) : (
          <>
            <div className="title-text">
              {getTextByKey("jumbopay-failed-payment-button-title")}
            </div>
            <div className="subtitle-text">
              {getTextByKey("jumbopay-failed-payment-button-text")}
            </div>
            <Button
              title={getTextByKey("jumbopay-failed-payment-button-button")}
              onClick={() => {
                setProcessStage(1);
              }}
            />
          </>
        )}
      </div>
    </div>
  );
};

const JumboPayProcessModal = () => {
  const { getMailId, getPaymentData } = useMail();
  const { getTextByKey } = useContent();
  const [processStage, setProcessStage] = useState(1);
  const [externalBlurStatus, setExternalBlurStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [src, setSrc] = useState("");
  const [transactionId, setTransactionid] = useState(0);
  const [isSuccess, setIsSuccess] = useState(null);
  const { login, isLoggedIn } = useUser();
  const { addToast } = useToasts();

  const paymentData = getPaymentData();

  const transactionRequest = async (requestObj) => {
    const response = await apiRequest(
      "Transactions",
      "ClientCheckoutSubmitReact",
      requestObj,
      "POST"
    );
    if (response.status === "success") {
      setExternalBlurStatus(response.data);
    }
    return response;
  };

  const handleSubmit = async (data) => {
    if (data.Password && data.Password !== data.PasswordValidation) {
      return {
        status: "error",
        message: "passwords-dont-match-message",
      };
    }
    if (externalBlurStatus && !isLoggedIn()) {
      return {
        status: "error",
        message: "user-mail-exist",
      };
    }

    const requestObj = {
      TransactionEmail: data.Email,
      TransactionFirstName: data.FirstName,
      TransactionLastName: data.LastName,
      TransactionInvoiceId: data.IdNumber,
      TransactionPhone: data.PhoneNumber,
      TransactionInvoiceName: data.NameForReceipt,
      TransactionEncryptedMailId: getMailId(),
      TransactionCountryId: 0,
      TransactionPriceDisplayedToUser: getPaymentData().Price,
      TransactionPurchaseProvider: data.PaymentMethod,
      TransactionPurchaseType: "files",
      TransactionUserIsAuthenticated: true,
      TransactionUserPassword: data.Password || null,
      TramsactionCurrency: "NIS",
      getOnlyIframe: true,
      TransactionPackageName: "payment",
      RecaptchaResponse: data.recaptchaResponse,
    };

    setLoading(true);
    const response = await transactionRequest(requestObj);

    if (response?.status === "success") {
      setSrc(response.data.PaymentPageUrl);
      setTransactionid(response.data.PaymentPageTransactionId);
      setProcessStage(2);
      if (data.Password) {
        const loginBody = {
          Password: data.Password,
          Remember: false,
          UserName: data.Email,
          recaptchaResponse: data.recaptchaResponse,
        };

        const response = await login(loginBody);

        if (response.status === "success") {
          addToast(getTextByKey("sign-in-success"), {
            appearance: response.status,
          });
        }
      }
    }

    setLoading(false);
    return response;
  };

  // todo - implement it in good way, anyway now it`s not working
  // need to create custom Email field with functionality on blur to check if mail is exist
  const checkIfMailIsExist = async (value) => {
    const response = await apiRequest("Users", "ReactCheckMailExist", {
      email: value,
    });
    if (response.status === "success") {
      setExternalBlurStatus(response.data);
    }
  };

  const formRef = useRef();

  const receiveMessage = (event) => {
    const message = JSON.stringify(event.data);
    if (
      message?.includes("purchase-files-result") &&
      !message?.includes("error")
    ) {
      setIsSuccess(true);
      window.dataLayer.push({
        event: "purchase",
        transaction_id: transactionId,
        ecommerce: {
          currency: currencies[paymentData.Currency],
          items: [
            {
              item_name: "Jumbo pay reciepent",
              item_id: "6",
              price: paymentData.Price,
              quantity: "1",
            },
          ],
        },
      });
      setProcessStage(3);
    } else if (message?.includes("error")) {
      setIsSuccess(false);
      setProcessStage(3);
    }
  };

  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    return () => {
      window.removeEventListener("message", receiveMessage);
    };
  }, []);

  return (
    <div className="jumbopay-process-modal">
      <div className="jumbopay-process-header">
        <div className="payment-progress-container">
          <Progressbar
            completed={
              processStage > 1 ? (processStage + 1) / 0.04 : processStage / 0.04
            }
            color="#15B4D4"
            height="4px"
            animation={100}
          />
          <div className="payment-milestones-container">
            <div
              className={`payment-milestone passed ${
                processStage >= 1 ? "clickable" : ""
              }`}
              onClick={() => {
                if (processStage > 1) {
                  setProcessStage(1);
                }
              }}
            >
              <div className="stage-number">1</div>
              <div className="stage-text">
                {getTextByKey("billing-info-text")}
              </div>
            </div>
            <div
              className={`payment-milestone ${
                processStage >= 2 ? "passed" : ""
              }`}
            >
              <div className="stage-number">2</div>
              <div className="stage-text">
                {getTextByKey("payment-method-text")}
              </div>
            </div>
            <div
              className={`payment-milestone ${
                processStage >= 3 ? "passed" : ""
              }`}
            >
              <div className="stage-number">
                <Icon name="check" white />
              </div>
              <div className="stage-text">{getTextByKey("check-out-text")}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="jumbopay-process-content">
        {processStage === 1 ? (
          <StageOneComponent
            {...{
              handleSubmit,
              checkIfMailIsExist,
              externalBlurStatus,
              formRef,
            }}
          />
        ) : processStage === 2 ? (
          <div className="iframe-container">
            <iframe id="react_id_iframe" src={src} title="billing" />
            <div className="ssl-security-image">
              <Image name="payment-protection" ext="JPG" />
            </div>
          </div>
        ) : (
          <ResultComponent
            isSuccess={isSuccess}
            setProcessStage={setProcessStage}
          />
        )}
      </div>
      {processStage === 1 ? (
        <div className="jumbopay-process-footer">
          <div>
            {getTextByKey("jumbopay-terms-text")}
            <LinkToNewTab page="jumbo-pay-terms" isNewTab={true}>
              {getTextByKey("terms-of-use")}
            </LinkToNewTab>
          </div>
          {loading ? (
            <LoadingImageElement />
          ) : (
            <Button
              onClick={() => {
                window.dataLayer.push({
                  event: "add_payment_info",
                  ecommerce: {
                    currency: currencies[paymentData.Currency],
                    items: [
                      {
                        item_name: "Jumbo pay reciepent",
                        item_id: "6",
                        price: paymentData.Price,
                        quantity: "1",
                      },
                    ],
                  },
                });
                externalSubmit(formRef);
              }}
            >
              {getTextByKey("next")}
            </Button>
          )}
        </div>
      ) : null}
    </div>
  );
};

export default JumboPayProcessModal;
